import getReviewList from "./getReviewList";
import createReview from "./createReview";
import getReview from "./getReview";

export default { getReviewList, createReview, getReview };
